<template>
  <div class="plan addon">
    <div class="body">
      <div class="plan-marketing-info">

        <div>
          <h3>{{ productAddon.productName }}</h3>
          <details class="addon-details | stack" v-if="productSummary && productDescription">
            <summary class="stack">
              <div v-html="productSummary"></div>
              <p class="a">More info</p>
            </summary>
            <div v-html="productDescription"></div>
          </details>
        </div>

        <img :src="productAddon.productImage" v-if="productAddon.productImage" class="plan-image"/>
      </div>

      <div class="addon-plans" v-if="!hidePlans">
        <div v-for="addon in productAddon.addons" :key="addon.id" class="addon-plan">
          <input :id="addon.id" type="checkbox" :true-value="addon.id" v-model="productAddon.selectedAddon"
          />
          <label class="addon-plan-label" :for="addon.id">
            <h4>{{ addon.name }}</h4>
            <PlanPricingFlow :pricing="addon.pricing" :horizontal="true"/>
            <button v-if="productAddon.selectedAddon !== addon.id" class="btn-a select">Select</button>
            <button v-if="productAddon.selectedAddon === addon.id" class="btn-a selected">Selected</button>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PlanPricingFlow from './PlanPricingFlow.vue';
import { mdToHtml } from "../../../utils/markdownToHtml";
</script>

<script>
export default {
  props: ["productAddon", "addonsMap", 'selectAddon', 'hidePlans'],

  components: { PlanPricingFlow },

  watch: {
    'productAddon': {
      handler() {
        this.$emit('update:modelValue', this.productAddon.selectedAddon);

        if (this.selectAddon) {
          this.selectAddon(this.productAddon, this.productAddon.selectedAddon);
        }
      },
      deep: true
    }
  },

  computed: {
    productSummary() {
      return mdToHtml(this.productAddon.productSummary || '')
    },
    productDescription() {
      return mdToHtml(this.productAddon.productDescription || '')
    }
  }
}
</script>
